import type { Theme } from '@mui/material';

import type { FocalAndComparisonAggregate } from 'src/types/dashboard';

// 'x', 'y' and 'r' are coordinates and sizes for the Bubble Chart. It is not possible to rename these keys.
interface BubbleData {
  label: string;
  r: number;
  x: number;
  y: number;
}

interface BubbleWidgetDataset {
  backgroundColor: string;
  data: BubbleData[];
  label: string;
}

/**
 * Gets an array of the focalAndComparisonAggregates and the bubble size and creates an array of BubbleWidgetDatasets.
 * The reducer only pushes the object into the array if 'focalAggregates' and 'comparisonAggregates' exist.
 */
export const generateBubbleWidgetDataset = (
  aggregates: FocalAndComparisonAggregate[],
  bubbleSize: number,
  theme: Theme,
): BubbleWidgetDataset[] =>
  aggregates.reduce(
    (bubbleWidgetDataset: BubbleWidgetDataset[], aggregates, index) => {
      if (aggregates.focalAggregate && aggregates.comparisonAggregate) {
        bubbleWidgetDataset.push({
          backgroundColor: theme.colors.neutral[100],
          data: [
            {
              label: `${index + 1}`,
              r: bubbleSize,
              x:
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                aggregates.focalAggregate.ptop2! -
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                aggregates.comparisonAggregate.ptop2!,
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              y: aggregates.focalAggregate.ptop2!,
            },
          ],
          label: aggregates.focalAggregate.label,
        } as BubbleWidgetDataset);
      }
      return bubbleWidgetDataset;
    },
    [] as BubbleWidgetDataset[],
  );
